import { Reveal } from "./Reveal";

export const Section = ({ id, eyebrow, title, intro, children, className = "" }) => (
  <section
    id={id}
    data-testid={`section-${id}`}
    className={`relative mx-auto w-full max-w-7xl px-5 py-20 sm:px-8 md:py-28 ${className}`}
  >
    {(eyebrow || title) && (
      <Reveal className="mb-12 max-w-3xl md:mb-16">
        {eyebrow && <p className="eyebrow mb-4">{eyebrow}</p>}
        {title && (
          <h2 className="font-display text-4xl font-semibold leading-[1.08] tracking-tight text-[#f7f4ef] sm:text-5xl">
            {title}
          </h2>
        )}
        {intro && <p className="mt-5 text-base leading-relaxed text-[#b5afa7] md:text-lg">{intro}</p>}
      </Reveal>
    )}
    {children}
  </section>
);
